export default __webpack_public_path__ + "static/media/menu-availability-icon.3ae451b9.svg";